var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPanacek(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "30px",
    viewBox: "0 0 17 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Panacek") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alikace",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "amber-plasma_muj-prehled_na-vasem-darovani-zalezi_V1",
    transform: "translate(-331, -214)",
    fill: "#F9AB00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(235, 214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Panacek",
    transform: "translate(96, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0823779192,15.0820273 C-0.119080235,14.7031101 0.0635596551,14.236056 0.471319245,14.1214845 C1.86127967,13.7307896 4.95772164,12.9884627 8.41845013,12.9884627 C11.8792179,12.9884627 14.9756598,13.7307896 16.3656334,14.1214845 C16.7733406,14.236056 16.956027,14.7031101 16.7545616,15.0820273 L9.01663014,29.6369992 C8.7592858,30.1210003 8.07761446,30.1210003 7.82033556,29.6369992 L0.0823779192,15.0820273 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7860393,5.46881262 C13.7860393,8.48915709 11.3828502,10.9376252 8.41845013,10.9376252 C5.45405008,10.9376252 3.05091981,8.48915709 3.05091981,5.46881262 C3.05091981,2.44846815 5.45405008,0 8.41845013,0 C11.3828502,0 13.7860393,2.44846815 13.7860393,5.46881262 Z",
    id: "Path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanacek);
export default __webpack_public_path__ + "static/media/Panacek.1491868126c22c2ee370457413a81770.svg";
export { ForwardRef as ReactComponent };